import { useRef } from 'react'

import { type DraggerUploadFilesRef } from '@/features/upload-files'
import { HeaderContent } from '@/shared/ui'
import { Col, Row } from 'antd'
import { useUnit } from 'effector-react'

import {
  documentCharterQuery,
  documentFacebookProfileDeletionGuideQuery,
  documentOfferQuery,
  documentPolicyQuery,
  documentTermsQuery,
} from './api'
import { UserPolicyTypeEnum } from './lib/policy-types'
import {
  SettingsDocumentsGate,
  charterSubmit,
  facebookProfileDeletionGuideSubmit,
  offerSubmit,
  policySubmit,
  termsSubmit,
} from './model/settings-policy.model'
import { PolicySection } from './ui/PolicySection'

export function PolicyPage() {
  const {
    data: policyData,
    pending: policyPending,
    error: policyError,
  } = useUnit(documentPolicyQuery)

  const {
    data: termsData,
    pending: termsPending,
    error: termsError,
  } = useUnit(documentTermsQuery)

  const {
    data: facebookProfileDeletionGuideData,
    pending: facebookProfileDeletionGuidePending,
    error: facebookProfileDeletionGuideError,
  } = useUnit(documentFacebookProfileDeletionGuideQuery)

  const {
    data: offerData,
    pending: offerPending,
    error: offerError,
  } = useUnit(documentOfferQuery)

  const {
    data: charterData,
    pending: charterPending,
    error: charterError,
  } = useUnit(documentCharterQuery)

  const submitTerms = useUnit(termsSubmit)
  const submitPolicy = useUnit(policySubmit)
  const submitFacebookProfileDeletionGuide = useUnit(
    facebookProfileDeletionGuideSubmit,
  )
  const submitOffer = useUnit(offerSubmit)
  const submitCharter = useUnit(charterSubmit)

  const termsDraggerRef = useRef<DraggerUploadFilesRef>(null)
  const policyDraggerRef = useRef<DraggerUploadFilesRef>(null)
  const facebookProfileDeletionGuideDraggerRef =
    useRef<DraggerUploadFilesRef>(null)
  const offerDraggerRef = useRef<DraggerUploadFilesRef>(null)
  const charterDraggerRef = useRef<DraggerUploadFilesRef>(null)

  const sections = [
    {
      title: 'Пользовательское соглашение',
      data: termsData,
      pending: termsPending,
      error: termsError,
      type: UserPolicyTypeEnum.TermsOfUse,
      onSubmit: submitTerms,
      draggerRef: termsDraggerRef,
    },
    {
      title: 'Политика обработки данных',
      data: policyData,
      pending: policyPending,
      error: policyError,
      type: UserPolicyTypeEnum.PrivacyPolicy,
      onSubmit: submitPolicy,
      draggerRef: policyDraggerRef,
    },
    {
      title: 'Инструкция по удалению профиля в Facebook',
      data: facebookProfileDeletionGuideData,
      pending: facebookProfileDeletionGuidePending,
      error: facebookProfileDeletionGuideError,
      type: UserPolicyTypeEnum.FacebookProfileDeletionGuide,
      onSubmit: submitFacebookProfileDeletionGuide,
      draggerRef: facebookProfileDeletionGuideDraggerRef,
    },
    {
      title: 'Оферта',
      data: offerData,
      pending: offerPending,
      error: offerError,
      type: UserPolicyTypeEnum.Offer,
      onSubmit: submitOffer,
      draggerRef: offerDraggerRef,
    },
    {
      title: 'Устав',
      data: charterData,
      pending: charterPending,
      error: charterError,
      type: UserPolicyTypeEnum.Charter,
      onSubmit: submitCharter,
      draggerRef: charterDraggerRef,
    },
  ] as const

  return (
    <>
      <SettingsDocumentsGate />

      <HeaderContent
        title="Документы"
        description="Раздел позволяет редактировать и добавлять документы."
      />

      <Row
        justify="center"
        align="top"
        gutter={[24, 24]}
        style={{ padding: 24 }}
      >
        {sections.map((section) => (
          <Col key={section.type} xs={24} sm={24} md={12} lg={8} xl={8}>
            <PolicySection {...section} />
          </Col>
        ))}
      </Row>
    </>
  )
}
